/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import QuantitySelector from "components/quantity-selector";
import Money from "components/money";
import SrOnly from "components/sr-only";

// ToDo: A better way to handle draft products
let skipItems = ['seal-skin-boat-cover-support-pole-deluxe', 'truck-cover-support-pole-deluxe'];

const CSItem = ({ item, setItems, isFree = false }) => {
    const [quantity, setQuantity] = useState(0);

    const title = item?.title ? item?.title : item?.shopify_product?.title;

    if(skipItems.includes(item?.handle)) {
        return;
    }
    
    useEffect(() => {
        if (quantity !== 0) setItems({ variantId: item?.shopify_product?.variants?.edges[0]?.node?.id, quantity });
    }, [quantity]);

    return (
        <div className="w-full flex py-0.5 items-center justify-between text-xs md:text-base leading-7" key={item?.id}>
            <img
                src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/checked.png?v=1625295005"
                className="mr-2.5 h-5 w-5"
                width="20"
                alt="Item to check"
            />
            <div className="capitalize basis-full">
                {isFree ? (title.includes("Storage Bag") ? "Storage Bag" : title) : title}
                <SrOnly label={isFree ? (title?.includes("Storage Bag") ? "Storage Bag" : title) : title} />
            </div>
            {!isFree && (
                <QuantitySelector 
                    quantity={quantity}
                    onQuantityChange={(value) => setQuantity(value)}
                    className="md:max-w-[8rem]"
                    isPDP
                    allowDecreaseToZero
                />
            )}
            <div className="font-bold text-[#080] min-w-[3rem] md:min-w-[6rem] text-right">
                {isFree ? "Free" : <Money value={item?.shopify_product?.variants?.edges[0]?.node?.price} /> }
                <SrOnly label={isFree ? "Free" : `${item?.shopify_product?.variants?.edges[0]?.node?.price.amount} ${item?.shopify_product?.variants?.edges[0]?.node?.price.currencyCode}`} />
            </div>
        </div>
    );
};

export default CSItem;
